import { ConfigStateService, eLayoutType, RoutesService } from '@abp/ng.core';
import { provideAppInitializer, inject } from '@angular/core';
import { MenuGeneratorService, MenuRouteModule } from '@zendra/shared';
import { GEOGRAPHIC_ROUTES } from 'geographic';
import { INVENTORY_ROUTES } from 'inventory';
import { OPERATIONAL_ROUTES } from 'operational';
import { SystemVersion } from 'projects/shared/src/lib/zn-version/services/system-version';
import { firstValueFrom } from 'rxjs';
import { filter, take } from 'rxjs/operators';

const MODULE_ROUTES: MenuRouteModule[] = [
  { path: 'geographic', routes: GEOGRAPHIC_ROUTES },
  { path: 'inventory', routes: INVENTORY_ROUTES },
  { path: 'operational', routes: OPERATIONAL_ROUTES },
];

export const APP_ROUTE_PROVIDER = [
  provideAppInitializer(() => {
    const routes = inject(RoutesService);
    const configState = inject(ConfigStateService);
    const menuGenerator = inject(MenuGeneratorService);
    const systemVersion = inject(SystemVersion);

    return firstValueFrom(
      configState.getOne$('auth').pipe(
        filter(auth => !!auth && !!auth.grantedPolicies),
        take(1)
      )
    ).then(() => {
      configureRoutes(routes, menuGenerator);
      systemVersion.getAppVersion();
    });
  }),
];

function configureRoutes(
  routes: RoutesService,
  menuGenerator: MenuGeneratorService
) {
  routes.add([
    {
      path: '/',
      name: 'LanguageService::Menu:Home',
      iconClass: 'fas fa-home',
      order: 1,
      layout: eLayoutType.application,
    },
  ]);

  routes.add(menuGenerator.buildAbpRoutes(MODULE_ROUTES));
  patchAbpRoutesToEnd(routes);
}

function patchAbpRoutesToEnd(routes: RoutesService) {
  routes.patch('AbpUiNavigation::Menu:Administration', {
    order: 100,
  });

  routes.patch('Saas::Menu:Saas', {
    order: 110,
  });
}
